import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconMoveUpStyle0 = gravityIconIndividualCss;

const GravityIconMoveUp = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '8e15a5affc5e0e8758bdbe22085611a47d10774b', color: this.color, size: this.size }, h("svg", { key: '92d2d196d463e8925305463a76a75651d4e9ed44', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '1ff42fe36b17e649092cbdde046cad48da59815b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.79 8.21-5.28 5.28a.3.3 0 0 0 .21.51h10.56a.3.3 0 0 0 .21-.51l-5.28-5.28a.29.29 0 0 0-.42 0Z", fill: "currentColor" }))));
    }
};
GravityIconMoveUp.style = GravityIconMoveUpStyle0;

export { GravityIconMoveUp as gravity_icon_move_up };

//# sourceMappingURL=gravity-icon-move-up.entry.js.map